import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Person\GetInvoiceableByIdController::__invoke
* @see app/Http/Controllers/Person/GetInvoiceableByIdController.php
* @route '/api/invoiceable/{invoiceable}'
*/
const GetInvoiceableByIdController = (args: { invoiceable: string | number } | [invoiceable: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetInvoiceableByIdController.url(args, options),
    method: 'get',
})

GetInvoiceableByIdController.definition = {
    methods: ["get","head"],
    url: '/api/invoiceable/{invoiceable}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Person\GetInvoiceableByIdController::__invoke
* @see app/Http/Controllers/Person/GetInvoiceableByIdController.php
* @route '/api/invoiceable/{invoiceable}'
*/
GetInvoiceableByIdController.url = (args: { invoiceable: string | number } | [invoiceable: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { invoiceable: args }
    }

    if (Array.isArray(args)) {
        args = {
            invoiceable: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        invoiceable: args.invoiceable,
    }

    return GetInvoiceableByIdController.definition.url
            .replace('{invoiceable}', parsedArgs.invoiceable.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Person\GetInvoiceableByIdController::__invoke
* @see app/Http/Controllers/Person/GetInvoiceableByIdController.php
* @route '/api/invoiceable/{invoiceable}'
*/
GetInvoiceableByIdController.get = (args: { invoiceable: string | number } | [invoiceable: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetInvoiceableByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Person\GetInvoiceableByIdController::__invoke
* @see app/Http/Controllers/Person/GetInvoiceableByIdController.php
* @route '/api/invoiceable/{invoiceable}'
*/
GetInvoiceableByIdController.head = (args: { invoiceable: string | number } | [invoiceable: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetInvoiceableByIdController.url(args, options),
    method: 'head',
})

export default GetInvoiceableByIdController